/**
 * <h3>UI控件库</h3>
 * <h5>事件类</h5>
 * {{#crossLink "bui.btn"}}{{/crossLink}}: 跳转,提交 <br>
 * <h5>滑动类</h5>
 * {{#crossLink "bui.list"}}{{/crossLink}}: 滚动加载,下拉刷新,快速版本 <br>
 * {{#crossLink "bui.searchbar"}}{{/crossLink}}: 搜索 <br>
 * {{#crossLink "bui.scroll"}}{{/crossLink}}: 滚动加载,下拉刷新控件 <br>
 * {{#crossLink "bui.pullrefresh"}}{{/crossLink}}: 下拉刷新控件 <br>
 * {{#crossLink "bui.sidebar"}}{{/crossLink}}: 菜单侧滑 <br>
 * {{#crossLink "bui.listview"}}{{/crossLink}}: 列表侧滑 <br>
 * {{#crossLink "bui.slide"}}{{/crossLink}}: 滑动控件 <br>
 * <h5>消息提醒</h5>
 * {{#crossLink "bui.hint"}}{{/crossLink}}: 自动消失的提醒 <br>
 * {{#crossLink "bui.alert"}}{{/crossLink}}: 弹出提醒,可以支持调试Object <br>
 * {{#crossLink "bui.confirm"}}{{/crossLink}}: 确认提醒 <br>
 * <h5>展示类</h5>
 * {{#crossLink "bui.accordion"}}{{/crossLink}}: 折叠菜单 <br>
 * {{#crossLink "bui.dialog"}}{{/crossLink}}: 弹出框 <br>
 * {{#crossLink "bui.stepbar"}}{{/crossLink}}: 步骤条 <br>
 * {{#crossLink "bui.loading"}}{{/crossLink}}: 加载进度 <br>
 * {{#crossLink "bui.mask"}}{{/crossLink}}: 遮罩 <br>
 * <h5>操作类</h5>
 * {{#crossLink "bui.select"}}{{/crossLink}}: 下拉选择菜单 <br>
 * {{#crossLink "bui.pickerdate"}}{{/crossLink}}: 日期控件 <br>
 * {{#crossLink "bui.dropdown"}}{{/crossLink}}: 下拉菜单 <br>
 * {{#crossLink "bui.actionsheet"}}{{/crossLink}}: 上拉菜单 <br>
 * {{#crossLink "bui.number"}}{{/crossLink}}: 数字增减条 <br>
 * {{#crossLink "bui.rating"}}{{/crossLink}}: 评分 <br>
 * {{#crossLink "bui.actionsheet"}}{{/crossLink}}: 上拉选择菜单 <br>
 * 
 * @module UI
 */
;(function (ui,$) {
/**
 * <h3>Mask遮罩控件</h3>
 * <a href="../../ui_controls/bui.mask.html" target="_blank">demo</a>
 * <p>默认引用的时候就会初始化,不想马上初始化需要使用 widget的方式 详情查看方法2</p>
 * <h5>方法</h5>
 * {{#crossLink "bui.mask/option"}}{{/crossLink}}: 获取设置参数 <br>
 * {{#crossLink "bui.mask/widget"}}{{/crossLink}}: 获取依赖控件 <br>
 * {{#crossLink "bui.mask/remove"}}{{/crossLink}}: 移除遮罩 <br>
 *  @namespace bui
 *  @class mask
 *  @constructor 
 *  @param {object} [option] 
 *     @param option.appendTo {string} [ 遮罩生成的位置,默认在body标签下 ]
 *     @param option.opacity {number} [ 透明度,小数点 ]
 *     @param option.background {string} [ 背景颜色 ]
 *     @param option.callback {function} [ 回调 ]
 * @example
 * 
        var uiMask = bui.mask();
 
 *
 */
    ui.mask = function(option){

        //默认配置
        var config = { 
            appendTo: "",       
            opacity:0.4,        
            background:"",      
            callback: null     
        }; 

        //方法
        var module = {
            add: add,
            hide: hide,
            show: show,
            remove: remove,
            widget: widget,
            option: options,
            config: param,
            init: init
        };
        //用于option方法的设置参数
        var param = module.config = $.extend(true,{}, config, ui.config.mask, option );
        
        var id ,
            method = {},
            $id,
            maskid,
            $mask,
            $children ;

        //执行初始化
        init(param);

        // 遮罩初始化
        function init (option) {
            option = option || param;
            
            // loading 可以加在body标签
            $id = option.appendTo ? $(option.appendTo): $('body');

            //option获取新参数使用
            param = module.config = option;

            $id.css("position","relative");
            $children = $id.children('.'+ui.prefix('mask'));

            //添加遮罩
            add(option);

            bind(option);
            
            return this;
        }
  
        //遮罩点击事件
        function bind (option) {

            option.callback && $mask.off("click.bui").on("click.bui",function (e) {

                option.callback.call(this,module);

                e.stopPropagation();

            })
        }
        //生成遮罩模板
        function template (option) {
            
                option = option || {};

                maskid = ui.guid();

            var bgcolor = option.background ? option.background: 'rgba(0,0,0,'+param.opacity+')';

            var html = '';
                html += '<div id="'+maskid+'" class="'+ui.prefix('mask')+'" style="background:'+bgcolor+';"></div>';

            return html;
        };

        //填充模板
        function render (option) {

            var tpl = template(option) ;
            $id.append(tpl);

            $mask = ui.obj(maskid);

            return this;
        };

        /*
         * 遮罩添加方法
         *  @method add
         *  @param {object} [option] 
         *     @param option.appendTo {string} [ 遮罩生成的位置,默认在body标签下 ]
         *     @param option.opacity {number} [ 遮罩的透明度,小数点 ]
         *     @param option.background {string} [ 遮罩的背景颜色 ]
         *     @param option.callback {function} [ 遮罩点击的回调 ]
         *  @chainable
         *  @example 
            var uiMask = bui.mask();
                uiMask.add();

         */
        
        function add (option) {
            
            render(option);

            return this;
        }
        /*
         * 隐藏遮罩
         *  @method hide
         *  @example 
            var uiMask = bui.mask();
                uiMask.hide();

         */
        
        function hide(argument) {

            if( $mask ){
                
                $mask.hide();

                $id.css("position","static");

            }
            return this;
        }

        /*
         * 显示遮罩
         *  @method show
         *  @example 
            var uiMask = bui.mask();
                uiMask.show();

         */
        function show(argument) {

            if( $mask ){
                
                $mask.show();

                $id.css("position","relative");

            }
            return this;
        }

        
        /**
         * 遮罩移除方法
         *  @method remove
         *  @chainable
         *  @example 
            var uiMask = bui.mask();
                uiMask.remove();
                
         */
        
        function remove (option) {

            option = option || {};

            if( $mask ){
                
                $mask.remove();

                $id.css("position","static");

            }
            return this;
        }

        /**
         * 获取依赖的控件
         *  @method widget
         *  @param {string} [name] [ 依赖控件名 ]
         *  @example 
            
            //获取依赖控件
            var uiMaskWidget = uiMask.widget();
            
                
         */
        function widget(name) {
            var control = {};
            return ui.widget.call(control,name);
        };
        /**
         * 获取设置参数
         *  @method option
         *  @param { string | object } [key] [ 不传则获取所有参数, 类型为string,没有第2个参数则获取某个参数 ]
         *  @param { string | number | boolean | function } [value] [ 设置参数的时候要传,设置多个参数不用传,获取参数的时候也不用传 ]
         *  @chainable
         *  @example 
            
            
            //获取所有参数
             //获取所有参数
            var option = uiMask.option();

            //获取某个参数
            var id = uiMask.option( "appendTo" );

            //修改一个参数
            uiMask.option( "opacity",0.5 );

            //修改多个参数
            uiMask.option( {"opacity":0.5} );
                
         */
        function options (key,value) {

           return ui.option.call(module,key,value);
        }

        return module;
    };


    return ui;

})( bui || {}, libs );

